import React from "react";
import Modal from "react-bootstrap/Modal";
import "./ConfirmationModal.scss";
import StatusIcon from "../../../img/warning.png";
import Image from "react-bootstrap/Image";
import useTranslationCommon from "../useTranslationCommon.js";
import useShowLoader from "../loading-widgets/useShowLoader.js";
import ActionButton from "../widgets/ActionButton.js";
import StringUtils from "../../../utils/StringUtils.js";

export default function ConfirmationModal({show, onDismiss, onConfirm, children, loading, className}) {

  const handleConfirm = (event) => {
    event.preventDefault();
    onConfirm();
  };

  const { t, loading: tLoading } = useTranslationCommon();
  useShowLoader(tLoading, "ConfirmationModal");

  // RENDER

  return (
    <Modal show={show} onHide={onDismiss} className={`ConfirmationModal ${StringUtils.isNullOrEmpty(className) ? "" : className}`}>
      <Modal.Body>
        <div>
          <Image src={StatusIcon} className={"status-icon"} />
        </div>
        <div>{children ? children : null}</div>
        <div className={"button-row"}>
          <ActionButton onClick={onDismiss}>
            {t("common:confirmation_cancel_button")}
          </ActionButton>
          <ActionButton onClick={handleConfirm} loading={loading}>
            {t("common:confirmation_confirm_button")}
          </ActionButton>
        </div>
      </Modal.Body>
    </Modal>
  );
}
